import axios from "../../../service/index";
import React, { Component } from "react";
import { message, Spin, Button, Icon, Table, Modal, Select } from "antd";
import moment from "moment";
import information from "../../../assets/images/information.png";
import "./info.less";
import { getQueryVariable } from "../../../utils/util";
import title1 from "../../../assets/images/students@3x.png";
import title2 from "../../../assets/images/status@3x.png";
import title3 from "../../../assets/images/students@3x.png";

const { Option } = Select;
let corpid = "ww05f5d2c3824d6d4e";
let agentid = window.location.href.indexOf("http://test-videocadmin") > -1
  ? "1000027"
  : "1000025"; // 应用id
class ServerInfo extends Component {
  state = {
    subjectOptions: [],
    typeTitel: "add",
    infoObj: {},
    userId: "",
    loading: true,
    isShowDialog: false,
    isShowModifyDialog: false,
    zxsUserId: "",
    zhilianglist: [],
    detailObj: {},
    dataSource: [],
    columns: [
      {
        title: "跟单人",
        dataIndex: "name",
        key: "name",
        ellipsis: true,
        width: 10,
        render: (record) => <div>{this.state.infoObj.stuTeacher}</div>,
      },
      {
        title: "跟单时间",
        dataIndex: "createtime",
        key: "createtime",
        ellipsis: true,
        width: 20,
      },
      {
        title: "跟单内容",
        dataIndex: "remark",
        key: "remark",
        ellipsis: true,
        width: 18,
      },
      {
        title: "操作",
        width: 8,
        align: "center",
        render: (record) => (
          <span
            className="seeDetailBtn"
            onClick={this.seeDetail.bind(this, record)}
          >
            查看
          </span>
        ),
        key: "opt",
      },
    ],
    selectValue: "", // 修改学员质量
    tracelist: [],
    checkLevelList: ["A", "B", "C", "D", "E", "F", "G"],
    initSelectValue: "",
    loginingStatus: false
  };
  componentDidMount() {
    let code = getQueryVariable("code");
    let state = getQueryVariable("state");
    if (code) {
      this.setState(
        {
          zxsCode: code,
        },
        function () {
          this.getZXSUserId(code);
        }
      );
    }
    if (state) {
      this.setState({ userId: state }, function () {
        this.userMsg(state);
      });
      this.getZhilianglist();
      this.getTracelist();
      return;
    }
    this.InitConfig();
  }
  InitConfig() {
    this.setState({ loading: true });
    let _this = this;
    let windowurl =
      window.location.href.split("#")[0] ||
      "http://test-videocadmin.codingke.com/info";
    // let windowurl = "http://test-videocadmin.codingke.com/info"
    let formdata = new FormData();
    formdata.append("url", windowurl);
    axios.post("config", formdata).then((res) => {
      let dataObj = res.data.data;
      let params = {
        timestamp: dataObj.timestamp, // 必填，生成签名的时间戳
        nonceStr: dataObj.noncestr,
      };
      window.wx.config({
        ...params,
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: corpid, // 必填，企业微信的corpID
        signature: dataObj.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [
          "getCurExternalContact",
          "showOptionMenu",
          "showMenuItems",
          "onMenuShareTimeline",
        ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      window.wx.ready(function () {
        let newformdata = new FormData();
        newformdata.append("url", windowurl);
        newformdata.append("noncestr", dataObj.noncestr);
        newformdata.append("timestamp", dataObj.timestamp);
        axios.post("agentConfig", newformdata).then((res) => {
          let data = res.data.data;
          window.wx.agentConfig({
            ...params,
            corpid: corpid, // 必填，企业微信的，必须与当前登录的企业一致
            agentid: agentid, // 必填，企业微信的应用id
            signature: data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
            jsApiList: [
              "getCurExternalContact",
              "showOptionMenu",
              "showMenuItems",
              "onMenuShareTimeline",
            ], //必填，传入需要使用的接口名称
            success: function (res) {
              window.wx.invoke("getCurExternalContact", {}, function (res) {
                _this.setState({ userId: res.userId }, () => {
                  if (res.userId) {
                    _this.getUserAuthurl(res.userId);
                  }
                });
              });
              if (res.err_msg === "getCurExternalContact:ok") {
                console.log(res);
              } else {
                //错误处理
              }
            },
            fail: function (res) {
              _this.setState({ loading: false });
              if (res.errMsg.indexOf("function not exist") > -1) {
                message.error("版本过低请升级");
              }
            },
          });
        });
      });
    });
  }

  formattime = (time) => {
    if (time) {
      return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
    }
    return "";
  };

  // 获取鉴权链接
  getUserAuthurl(userId) {
    axios.get(`wxAuth/api/userAuthurl?stuId=${userId}`).then((res) => {
      const { msg, code, data } = res.data;
      if (code === "200") {
        window.location.href = data;
      } else {
        message.error(msg);
      }
    });
  }

  // 获取咨询师id
  getZXSUserId(code) {
    axios.get(`wxAuth/api/getUserId/${code}`).then((res) => {
      const { msg, code, data } = res.data;
      if (code === "200") {
        this.setState({
          zxsUserId: data,
        });
      } else {
        message.error(msg);
      }
    });
  }

  // 获取用户信息
  userMsg(userId) {
    let formdata = new FormData();
    formdata.append("userId", userId);
    axios.post("getUserInfo", formdata).then((res) => {
      this.setState({ loading: false });
      let data = res.data;
      let initSelectValue = data.data.zhiliang;
      if (data.code === "200") {
        this.setState({ infoObj: data.data, initSelectValue, loginingStatus:true }, function () {
          if (data.data.askId) {
            this.getRecordList();
          }
        });
      } else {
        message.error(data.msg);
      }
    });
  }

  // 查看跟单详情
  seeDetail(data) {
    this.setState({
      isShowDialog: true,
      detailObj: data,
    });
  }

  // 取消弹框
  cancelFn() {
    this.setState({
      isShowDialog: false,
      isShowModifyDialog: false,
      detailObj: {},
    });
  }

  // 修改类型
  onOk() {
    if (!this.state.selectValue) {
      message.error("请选择质量类型！");
      return;
    }
    if (this.state.initSelectValue > this.state.selectValue) {
      message.error("抱歉，不能进行降级修改");
      return;
    }
    const { infoObj, selectValue } = this.state;
    let formdata = new FormData();
    formdata.append("askId", infoObj.askId);
    formdata.append("zhiliangID", selectValue);
    axios
      .post(`updateZhiLiang/${infoObj.askId}/${selectValue}`, formdata)
      .then((res) => {
        this.setState({ loading: false });
        let data = res.data;
        if (data.code === "200") {
          this.setState({
            isShowModifyDialog: false,
          });
          this.userMsg(this.state.userId);
        } else {
          message.error(data.msg);
        }
      });
  }

  // 切换质量类型选项
  handleChange(value) {
    this.setState({
      selectValue: value,
    });
    console.log(`selected${value}`);
  }

  // 跳转到详情页面
  goAddRecordPage() {
    const { infoObj } = this.state;
    this.props.history.push({
      pathname: "/addRecord",
      state: { askId: infoObj.askId, kefuId: infoObj.kefuId },
    });
  }

  // 打开修改质量模态框
  modifyMsgBtn() {
    this.setState({
      selectValue: Number(this.state.infoObj.zhiliang),
      isShowModifyDialog: true,
    });
  }

  // 获取质量类型列表
  getZhilianglist() {
    axios.post("zhilianglist", {}).then((res) => {
      this.setState({ loading: false });
      const { msg, data, code } = res.data;
      console.log(msg, data, code);
      if (code === "200") {
        this.setState({ zhilianglist: data });
      } else {
        message.error(msg);
      }
    });
  }

  // 获取跟单学员类型字典
  getTracelist() {
    axios.post("tracelist", {}).then((res) => {
      this.setState({ loading: false });
      const { msg, data, code } = res.data;
      console.log(msg, data, code);
      if (code === "200") {
        this.setState({ tracelist: data });
      } else {
        message.error(msg);
      }
    });
  }

  // 获取跟单列表
  getRecordList() {
    let { infoObj } = this.state;
    axios.post(`documentaryRecord/list/${infoObj.askId}`, {}).then((res) => {
      this.setState({ loading: false });
      const { msg, data, code } = res.data;
      console.log("跟单列表", msg, data, code);
      if (code === "200") {
        this.setState({
          dataSource: data,
        });
      } else {
        message.error(msg);
      }
    });
  }

  render() {
    let {
      infoObj,
      loading,
      userId,
      isShowDialog,
      isShowModifyDialog,
      dataSource,
      columns,
      zhilianglist,
      selectValue,
      detailObj,
      tracelist,
      zxsUserId,
      loginingStatus
    } = this.state;
    return (
      <div className="myInfoPage">
        <Spin spinning={loading}>
          <div
            style={{
              display:
                infoObj.name && infoObj.userType === "2" ? "block" : "none",
            }}
            className="server-info"
          >
            <div className="baseInfo">
              <p className="title">
                <img src={title1} alt="title1" />
                <span>学员基本信息</span>
              </p>
              <div className="content">
                <dl>
                  <dt>姓名：</dt>
                  <dd>{infoObj.name || "无"}</dd>
                </dl>
                {/* <dl>
              <dt>学员类型： </dt>
              <dd>{infoObj.type==='1'?'存量':infoObj.type==='2'?'新增':''}</dd>
            </dl> */}
                <dl>
                  <dt>手机号：</dt>
                  <dd>{infoObj.phone || "无"}</dd>
                </dl>
                <dl>
                  <dt>意向学科：</dt>
                  <dd>{infoObj.stuName || "无"}</dd>
                </dl>
              </div>
            </div>
            <div
              className="studentStatus"
              style={{
                display:
                  infoObj.phone && infoObj.stuTeacher !== "" ? "block" : "none",
              }}
            >
              <p className="title">
                <img src={title2} alt="title2" />
                <span>学员状态信息</span>
              </p>
              <div className="content status-c">
                <dl>
                  <dt>类型：</dt>
                  <dd>{infoObj.stuType || "无"}</dd>
                </dl>
                <dl>
                  <dt>来源渠道：</dt>
                  <dd>{infoObj.stuFrom || "无"}</dd>
                </dl>
                <dl>
                  <dt>咨询师：</dt>
                  <dd>{infoObj.stuTeacher || "无"}</dd>
                </dl>
                <dl>
                  <dt>咨询师所在部门：</dt>
                  <dd>{infoObj.stuTeacherDept || "无"}</dd>
                </dl>
                <dl>
                  <dt>分配时间：</dt>
                  <dd>{this.formattime(infoObj.stuFpTime) || "无"}</dd>
                </dl>
                <dl>
                  <dt>跟单时间：</dt>
                  <dd>{this.formattime(infoObj.stuGdTime) || "无"}</dd>
                </dl>
                <dl>
                  <dt>状态：</dt>
                  <dd>
                    <span>
                      {infoObj.status === "1"
                        ? "已报名"
                        : infoObj.status === "2"
                        ? "未报名"
                        : ""}
                    </span>
                  </dd>
                </dl>
                <dl>
                  <dt>学员质量：</dt>
                  <dd>
                    <span>{zhiliangShow(zhilianglist, infoObj) || "无"}</span>
                    {infoObj.wechatId === zxsUserId && (
                      <span
                        className="editBtn"
                        onClick={this.modifyMsgBtn.bind(this)}
                      >
                        <Icon type="form" />
                        修改
                      </span>
                    )}
                  </dd>
                </dl>
              </div>
            </div>
            <div className="record">
              <div className="title">
                <div>
                  <img src={title3} alt="title3" />
                  <span>跟单记录</span>
                </div>
                {infoObj.wechatId === zxsUserId && (
                  <span onClick={this.goAddRecordPage.bind(this)}>
                    <Icon type="plus-circle" />
                    添加
                  </span>
                )}
              </div>
              <Table
                rowKey="createtime"
                pagination={false}
                columns={columns}
                dataSource={dataSource}
              />
            </div>
          </div>
          <Modal
            onCancel={this.cancelFn.bind(this)}
            title="跟单详情"
            visible={isShowDialog}
            footer={null}
            wrapClassName="dialogByInfo"
          >
            <div>
              <span>跟单人：</span>
              <span>{infoObj.stuTeacher}</span>
            </div>
            <div>
              <span>学员类型：</span>
              <span>{traceShow(tracelist, infoObj)}</span>
            </div>
            <div>
              <span>本次跟单时间：</span>
              <span>{handleTime(detailObj.createtime) || "无"}</span>
            </div>
            <div>
              <span>下次跟单时间：</span>
              <span>{handleTime(detailObj.nexttracetime) || "无"}</span>
            </div>
            <div>
              <span>预计学习时间：</span>
              <span>{handleTime(detailObj.planstudytime) || "无"}</span>
            </div>
            <div>
              <span>本次跟单内容：</span>
              <span>{detailObj.remark || "无"}</span>
            </div>
          </Modal>
          <Modal
            onCancel={this.cancelFn.bind(this)}
            onOk={this.onOk.bind(this)}
            title="修改学员质量"
            visible={isShowModifyDialog}
            wrapClassName="modifyDialogByInfo"
          >
            <div className="label">质量类型：</div>
            <Select
              value={selectValue}
              style={{ width: "100%" }}
              onChange={this.handleChange.bind(this)}
            >
              {zhilianglist.map((item) => {
                return (
                  <Option key={item.did} value={item.did}>
                    {item.dname}
                  </Option>
                );
              })}
            </Select>
          </Modal>
          <div
            style={{
              display:
              loginingStatus&&(!infoObj.phone || infoObj.userType === "1") ? "block" : "none",
            }}
            className="server-msg"
          >
            <div className="msg-img">
              <img src={information} alt="" />
            </div>
            <div className="submit-btn">
              <Button
                type="primary"
                icon="form"
                onClick={(e) => {
                  this.props.history.push("/servercard", {
                    userId: userId,
                    name: infoObj.name,
                  });
                }}
              >
                请输入学员信息
              </Button>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}
function zhiliangShow(zhilianglist, infoObj) {
  if (zhilianglist && zhilianglist.length > 0) {
    let item = zhilianglist.find(
      (item) => item.did === Number(infoObj.zhiliang)
    );
    return item && item.dname;
  }
}
function traceShow(tracelist, infoObj) {
  if (tracelist && tracelist.length > 0) {
    let item = tracelist.find((item) => item.did === Number(infoObj.zstype));
    return item && item.dname;
  }
}
function handleTime(time) {
  if (!time) return false;
  return time.slice(0, 10);
}
export default ServerInfo;
